import { Epic, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { RootAction, RootState, Services } from 'typesafe-actions';
import { getAuthorizedLpSelected } from '../../actions/lp';
import { GET_AUTHORIZED_LP_SELECTED_REQUEST } from '../../actions/lp/actionTypes';

export const getLpSelectedEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  Services
> = (action$, state$, { api }) =>
  action$.pipe(
    ofType(GET_AUTHORIZED_LP_SELECTED_REQUEST),
    switchMap((action) =>
      from(
        api.clwsServices.getLpDetailsService().pipe(
          mergeMap(({ logisticsPartyDetails }) =>
            of(getAuthorizedLpSelected.success(logisticsPartyDetails))
          ),
          catchError((err) => of(getAuthorizedLpSelected.failure(err)))
        )
      )
    )
  );
export default getLpSelectedEpic;
